import { createClient } from "@supabase/supabase-js";

export type { Session } from "@supabase/supabase-js";

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

// All Edge Function calls go through the Cloudflare Worker, never directly to Supabase.
// supabase-js (DB + Auth) still uses SUPABASE_URL — the anon key is intentionally public.
export const API_URL = import.meta.env.VITE_API_URL as string;

// CF Workers disallow async I/O at global scope (fetch, timers, crypto).
// Disable session persistence and auto-refresh server-side to prevent
// Supabase from making background network calls during module initialization.
const isServer = typeof document === "undefined";
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: !isServer,
    autoRefreshToken: !isServer,
    detectSessionInUrl: !isServer,
  },
});

let goUserId: string | null = null;
export function setGoUserId(id: string | null) {
  goUserId = id;
}

export function goUrl(listingId: string, src: string): string {
  const u = goUserId ? `&u=${goUserId}` : "";
  return `${API_URL}/api/go?l=${listingId}&src=${src}${u}`;
}

export async function sendMagicLink(
  email: string,
  opts?: { redirectTo?: string; createUser?: boolean },
) {
  const { error } = await supabase.auth.signInWithOtp({
    email,
    options: {
      emailRedirectTo: opts?.redirectTo ?? `${window.location.origin}/auth/callback`,
      shouldCreateUser: opts?.createUser ?? false,
    },
  });

  if (error) {
    throw new Error(error.message ?? "Falha ao enviar link");
  }
}
